module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-photo-f11a542d03f1c1261f5bfaf2ff6a5f85.jpg";